import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormErrorDirective } from './form-error.directive';

@NgModule({
  declarations: [FormErrorDirective],
  exports: [FormErrorDirective],
  imports: [CommonModule],
})
export class FormErrorModule {}
